module.exports = __webpack_public_path__ + "static/img/footer_wchat.b63e984.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/footer_wchat.png
// module id = yD0w
// module chunks = 0